import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useStore } from '@nanostores/react';
import { useQueryClient } from '@tanstack/react-query';

export type DeleteProjectConfirmationProps = {
  isOpen: boolean;
  handleOpen: (boolean: boolean) => void;
  workflowId: string;
  onDeleteSuccess?: () => void;
};

export const DeleteWorkflowConfirmation = ({
  isOpen,
  handleOpen,
  workflowId,
  onDeleteSuccess,
}: DeleteProjectConfirmationProps) => {
  const queryClient = useQueryClient();
  const ws = useStore($workspace);
  const org = useStore($org);
  const [deletingWorkflow, setDeletingWorkflow] = useState(false);

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete this
            workflow and remove all the data and automations inside it from our
            servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={async e => {
              e.preventDefault();
              setDeletingWorkflow(true);
              await deleteWorkflow(workflowId); // ✅ use actual service call
              onDeleteSuccess?.(); // ✅ trigger the refetch manually from parent

              setDeletingWorkflow(false);
              handleOpen(false);
            }}
            disabled={deletingWorkflow}
            className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
          >
            {deletingWorkflow ? 'Processing...' : 'Continue'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
